import { takeLatest, put, call } from 'redux-saga/effects'

import {
  GET_USER_ROLES,
  GET_USER_FEATURES,
  CHECK_USER_POLICY,
  UPDATE_USER_POLICY,
} from './constants'
import {
  getUserRolesSuccess,
  getUserRolesFailure,
  getUserFeaturesSuccess,
  getUserFeaturesFailure,
  checkUserPolicySuccess,
  updateUserPolicySuccess,
} from './actions'
import { usersServices } from 'services'
import { getUserFeatures } from 'repositories/BerthApi/getUserFeatures'

function* getUserRolesProcess({ payload }) {
  try {
    const { data } = yield call([usersServices, 'getUserRoles'], payload)
    yield put(getUserRolesSuccess(data || {}))
  } catch (error) {
    yield put(getUserRolesFailure())
  }
}

function* getUserFeaturesProcess() {
  try {
    // repositories/BerthApi/getUserFeatures は { data: { canViewShipmentList } } を返す
    const { data } = yield call(getUserFeatures)
    yield put(getUserFeaturesSuccess(data || {}))
  } catch (error) {
    yield put(getUserFeaturesFailure())
  }
}

function* checkUserPolicyProcess() {
  try {
    const { data = {} } = yield call([usersServices, 'checkUserPolicy'])
    yield put(checkUserPolicySuccess(data.display_policy_version || {}))
  } catch (error) {}
}

function* updateUserPolicyProcess({ payload }) {
  try {
    yield call([usersServices, 'updateUserPolicy'], payload)
    yield put(updateUserPolicySuccess())
  } catch (error) {}
}

function* watchSaga() {
  yield takeLatest(GET_USER_ROLES, getUserRolesProcess)
  yield takeLatest(GET_USER_FEATURES, getUserFeaturesProcess)
  yield takeLatest(CHECK_USER_POLICY, checkUserPolicyProcess)
  yield takeLatest(UPDATE_USER_POLICY, updateUserPolicyProcess)
}

export default watchSaga
